import Modal from '../../../Modal/index';
import {
  Container,
  Title,
  Footer,
  DivIcon,
  Content,
  SubTitle,
} from './styles';
import Button from '../../../Button';
import Close from '../../../../../assets/icons/Close';
export const ConfirmationModal = ({
  onConfirm = () => console.log('activate'),
  flow = { title: "Projeto" },
  isOpen,
  onClose,
  selector = '#root',
  className = null,
}) => {

  const title = flow?.title;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Fluxo criado!</Title>
        <SubTitle>
          {"Deseja ir até o novo fluxo?"}
        </SubTitle>
        <Content>
          {title}
        </Content>
        <Footer>
          <Button
            outline
            content="Fechar"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={onClose}
          />
          <Button
            greenBase
            content="Ir"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={onConfirm}
          />
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>

      </Container>
    </Modal>
  );
};
